import { render } from "./VideoLoadingComponent.vue?vue&type=template&id=0733dff0&scoped=true"
import script from "./VideoLoadingComponent.vue?vue&type=script&lang=ts"
export * from "./VideoLoadingComponent.vue?vue&type=script&lang=ts"

import "./VideoLoadingComponent.vue?vue&type=style&index=0&id=0733dff0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0733dff0"

export default script